<template>
    <div class="content-body" v-if="!disabled">
        <el-row id="select_slot_header">
            <h1 id="select_slot_title">
                {{$t("bookingOrder.selectSlotTitle")}}
            </h1>
            <h3 id="date_and_time_range_title">{{$t("bookingOrder.dateAndTimeRangeTitle")}}</h3>
            <span id="date_and_time_range_ordered">{{dateAndTimeRangeWasOrdered}}</span>
        </el-row>

        <el-row id="list_slot_type_wrapper">
            <el-form v-loading="loading">
                <el-form-item id="slot_type" v-for="(bookingSlotType, key) in bookingSlotTypes" prop=""
                              :label='bookingSlotType.name'>

                    <el-input ref="code" type="number" min="0"
                              autocomplete="disabled"
                              aria-autocomplete="none" v-model="numberOfTypeSlot[key]"
                              :placeholder='bookingSlotType.name'></el-input>
                </el-form-item>

            </el-form>
        </el-row>

        <el-row id="confirm_to_pay_ordered_booking_button_wrapper">
            <el-button id="confirm_to_pay_ordered_booking_button" @click="confirmToPayOrderedBooking">
                {{$t("bookingOrder.continueToConfirmPaymentButton")}}
            </el-button>
        </el-row>

        <el-row id="back_button_wrapper">
            <el-button id="back_button" @click="back">{{$t("bookingOrder.backButton")}}</el-button>
        </el-row>
    </div>

</template>

<script>
    import Header from "../../../layouts/modules/Header";
    import BookingApi from "../../../api/booking/BookingApi";
    import AlertService from "../../../service/alert.service";

    export default {
        name: "SelectSlotToOrderBooking",
        components: {Header},

        data() {
            return {
                dateAndTimeRangeWasOrdered: "2020/02/26 10:00-11:00",
                loading: false,
                selectedTimeRangCode: null,
                orderedDate: null,
                bookingTimeRangStatus: null,
                disabled: false,
                bookingOrder: {},
                bookingSlotTypes: [],
                numberOfTypeSlot: [],
                facilityCode: ""
            }
        },

        created() {
            this.disabled = false
            this.orderedDate = this.$route.query.orderedDate;
            this.selectedTimeRangCode = this.$route.query.timeRangCode;
            this.facilityCode = this.$route.query.facilityCode;

            if (this.selectedTimeRangCode != null && this.orderedDate != null) {
                BookingApi.getByTimeRangeAndDate(this.selectedTimeRangCode, this.orderedDate).then(result => {
                    console.log("Result: ")
                    console.log(result)
                    this.$emit('setFacilityLogoUrl', result.facilityLogoUrl);
                    this.bookingTimeRangStatus = result;
                    let startHour = result.bookingTimeRange.startHour;
                    let endHour = result.bookingTimeRange.endHour;
                    let startMinute = result.bookingTimeRange.startMinute;
                    let endMinute = result.bookingTimeRange.endMinute;
                    let timeRang = startHour + ":" + ((startMinute != 0) ? startMinute : "00") + " - " + endHour + ":" + ((endMinute != 0) ? endMinute : "00");
                    this.dateAndTimeRangeWasOrdered = this.orderedDate + " " + timeRang;
                })

                BookingApi.getByBookingTimeRange(this.selectedTimeRangCode).then(result => {
                    this.bookingSlotTypes = result;
                    console.log(result)

                    for (let i = 0; i < this.bookingSlotTypes.length; i++) {
                        this.numberOfTypeSlot[i] = 0;
                    }
                })
            } else {
                this.$router.push({path: "/home"});
            }
        },

        methods: {
            back() {
                this.$router.push({path: "/home?code=" + this.facilityCode});
            },

            confirmToPayOrderedBooking() {
                let bookedSlotTotal = 0;

                function invalidNumber(i) {
                    return i === undefined || i == null || isNaN(i) || parseInt(i) === 0 || i.trim() === "";
                }

                for (let i = 0; i < this.bookingSlotTypes.length; i++) {
                    if (invalidNumber(this.numberOfTypeSlot[i])) this.numberOfTypeSlot[i] = 0;

                    bookedSlotTotal += parseInt(this.numberOfTypeSlot[i]);
                    console.log(this.numberOfTypeSlot[i])
                }
                /**Calculate max slot of time range at this date.*/
                let timeRangeCustoms = this.bookingTimeRangStatus.bookingTimeRange.bookingTimeRangeCustoms;
                let maxSlot = this.bookingTimeRangStatus.bookingTimeRange.maxSlot;
                for (let i = 0; i < timeRangeCustoms.length; i++) {
                    let customDate = timeRangeCustoms[i].date.split("-").join("/");
                    if (customDate === this.orderedDate) {
                        maxSlot = timeRangeCustoms[i].maxSlot;
                        break;
                    }
                }

                let availableNumberOfSlot = maxSlot - this.bookingTimeRangStatus.numberBookedSlot;
                console.log(bookedSlotTotal)
                console.log(availableNumberOfSlot);
                if (this.bookingTimeRangStatus == null || bookedSlotTotal <= 0) {
                    AlertService.error(this.$t('bookingOrder.pleaseEnterSlot'))
                } else {
                    if (bookedSlotTotal <= availableNumberOfSlot) {
                        this.bookingOrder = {
                            bookingTimeRangeStatus: this.bookingTimeRangStatus,
                            bookingSlotTypes: this.bookingSlotTypes,
                            numberOfTypeSlot: this.numberOfTypeSlot,
                        }

                        this.redirectConfirmDisplayToPay(this.bookingOrder)

                    } else {
                        AlertService.error(this.$t('bookingOrder.overSlotsMessage')  + availableNumberOfSlot + this.$t('bookingOrder.remainSlotIs'))
                    }
                }
            },

            redirectConfirmDisplayToPay(bookingOrder) {
                this.$emit('redirectConfirmDisplayToPay', bookingOrder);
            },

            hide() {
                this.disabled = true;
            },

            show() {
                this.disabled = false;
            },

            enableLoading() {
                this.loading = true;
            },

            disableLoading() {
                this.loading = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .content-body {
        margin-left: 20%;
        margin-right: 20%;
    }

    #select_slot_header {
        margin-bottom: 20px
    }

    #select_slot_title {
        font-weight: bold;
        font-size: 30px;
        text-align: center;
    }

    #date_and_time_range_ordered {
        padding-left: 30px
    }

    #list_slot_type_wrapper {
        padding-top: 0px
    }

    #slot_type {
        font-weight: bold
    }

    #confirm_to_pay_ordered_booking_button {
        background-color: #4B86E8;
        color: white;
        width: 300px;
        display: inline-block;
    }

    #confirm_to_pay_ordered_booking_button_wrapper {
        text-align: center;
    }

    #back_button_wrapper {
        text-align: center;
        margin-top: 10px
    }

    #back_button {
        width: 300px
    }

    @media only screen and (max-width: 1024px) {
        .content-body {
            margin-left: 15%;
            margin-right: 15%;
        }
    }

    @media only screen and (max-width: 768px) {
        .content-body {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 510px) {
        .content-body {
            width: 100%;
            margin-left: 0%;
            margin-right: 0%;
        }

        #confirm_to_pay_ordered_booking_button_wrapper {
            text-align: center;

            #confirm_to_pay_ordered_booking_button {
                background-color: #4B86E8;
                color: white;
                width: 100%;
                display: inline-block;
            }
        }

        #select_slot_title {
            margin-top: 0px;
            font-size: 110%;
            text-align: center;
        }

        #back_button {
            width: 100%
        }

        #date_and_time_range_title {
            font-size: 100%;
        }

        #date_and_time_range_ordered {
            font-size: 100%;
        }
    }

</style>